import React from 'react';
import './Cta.css'; // Vamos criar este arquivo de estilo a seguir

function Cta() {
    // IMPORTANTE: Substitua o número de telefone abaixo pelo seu.
    const whatsappNumber = "5537999826905";
    const whatsappMessage = "Olá! Gostaria de falar com um especialista sobre as soluções R6.";
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

    return (
        <section id="cta-section">
            <div className="container text-center">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <h2 className="display-5 fw-bold">Transforme sua gestão hoje mesmo.</h2>
                        <p className="lead my-3">
                            Fale com um especialista e descubra como o R6 ERP pode alavancar seus resultados.
                        </p>
                        <a
                            href={whatsappUrl}
                            className="btn btn-especialista mt-3"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Fale com um especialista
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Cta;